import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { IMAGES_URL, ALL_SERVICES, PLUS_MEMBERSHIP, COMMON_MODULES, LOGIN_PATH } from '@src/app/core/constants';
import { HelperService } from '@src/app/core/services/helper.service';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvBgContentComponent } from '@src/app/core/shared/components/mini-env/mini-env-bg-content/mini-env-bg-content.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvImgCardSlideComponent } from '@src/app/core/shared/components/mini-env/mini-env-img-card-slide/mini-env-img-card-slide.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MiniEnvTallInfoCardComponent } from '@src/app/core/shared/components/mini-env/mini-env-tall-info-card/mini-env-tall-info-card.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import * as aquoralJson from '@src/assets/i18n/mini-env/aquoral/en.json';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-aquoral',
  imports: [
             ...COMMON_MODULES,
              HeadingBlockOneModule,
              IconboxOneModule,
              IconboxTwoModule,
              HeadingBlockFullWidthModule,
              ImageboxOneModule,
              ImageboxFullwidthModule,
              CardboxOneModule,
              BannerOneModule,
              MiniEnvHeadingBlockComponent,
              MiniEnvFaqsComponent,
              MiniEnvBannerComponent,
              MiniEnvSubFooterComponent,
              MembershipPlanModule,
              MiniEnvTallInfoCardComponent,
              MiniEnvBgContentComponent,
              MiniEnvImgCardSlideComponent
  ],
  templateUrl: './aquoral.component.html',
  styleUrl: './aquoral.component.scss'
})
export class AquoralComponent extends CoreClass implements OnInit {
    IMAGES_URL: string = IMAGES_URL;
  faqList = aquoralJson.FAQS.FAQ_LIST;
  imgSrc = 'assets/tenant-assets/mini-env/images/people-in-kitchen.png';
  bgClass = 'father-child-bg';
  membershipCode = '';

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private helperService: HelperService,
    private httpClient: HttpClient
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  membershipPlanCode = '';
  panes: any[] = [{title: 'Concierge-level Healthcare', active: false},{title: 'Dental Services', active: false},{title: 'Exclusive Discount', active: false}];

  clinicalBenefits: any[] = aquoralJson.CLINICAL_BENEFITS.BENEFITS_LIST || [];
  sprayBenefits: any[] = aquoralJson.SPRAY_SECTION.BENEFITS_LIST || [];
  bannerSlides: any[] = aquoralJson.BANNER.BANNER_SLIDES || [];
  symptomsList: any[] = aquoralJson.DRY_MOUTH_SYMPTOMS.SYMPTOMS_LIST || [];


  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
    this.helperService.changeMiniEnvColor();
    this.setMiniEnvValues();
  }

  setMiniEnvValues() {
    this.httpService.requestEntity('GET', `assets/tenant-assets/mini-env/${environment.miniEnvFile}`).subscribe((res: any) => {   
      const miniEnvConfig = res?.body;  
      if (miniEnvConfig) {
        
        this.membershipPlanCode = miniEnvConfig['aquoral'].membershipPlanTypes;
      }
    })
  }

  scrollToPlans() {
    
    const section = document.getElementById('membership-section');

    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onSliderBtnAction(action: any) {
    if (action == 'login') {
      this.router.navigate([LOGIN_PATH]);
    } else {
      this.scrollToPlans();
    }
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

   ngAfterContentInit(): void {
    const panesArray = this.panes;

    // Ensure one tab is active
    const activePane = panesArray.find(p => p.active);
    if (!activePane && panesArray.length) {
      panesArray[0].active = true;
    }
  }

  select(index: number): void {
    this.panes.forEach((pane, i) => {
      pane.active = i === index;
    });
  }
}
